<script lang="ts">
  // components
  import CartProduct from "@retailer/svelte/Cart/Page/DistributorSection/CartProduct.svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { shouldHideAllDistributorInfo } from "@shared/services/retailer_user_authentication_service";
  import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  import { pluralize } from "@shared/svelte/Modules/pluralize";

  // types
  import type { CartOrderType } from "@shared/types/Cart";

  export let cartService: any; // Angular Service
  export let order: CartOrderType;
  export let callbacks: any;
  export let showLoading: boolean;
  export let customPricingMode;
  export let products;

  const hasRetailerUserAuthRollout = stagedRolloutCheck(
    "marketplace__retailer_user_authentication",
  );

  let hideAllDistributorInfo: boolean = false;
  $: {
    hideAllDistributorInfo =
      hasRetailerUserAuthRollout &&
      order?.distributor?.id &&
      shouldHideAllDistributorInfo($RetailerUserAuthenticationsStore, [order?.distributor?.id]);
  }

  $: requestedItems = products.filter(p => p.requested_item);
</script>

<div
  class="fizz-surface-gray fizz-full-width fizz-inset-horizontal-16 fizz-inset-vertical-12"
  data-testid="request-item-container"
>
  <div class="fizz-flex-row-8 fizz-stack-12">
    <div class="fizz-align-self-start">
      <Icon type="ErrorBlack" height="24" width="24" />
    </div>
    <div class="fizz-flex-vertical fizz-full-width">
      <div class="fizz-flex-row fizz-space-between fizz-text-strong">
        <p>Requested Items ({pluralize("item", requestedItems.length, true)}) </p>
        {#if !hideAllDistributorInfo}
          <p data-testid="requested-items-total"
            >+<FormatMoney input={order.requested_items_total} /></p
          >
        {/if}
      </div>
      <p class="fizz-text-subdued fizz-full-width fizz-text-small"
        >Unless these items are fulfilled, they won't count towards a distributor's order minimum or
        your order total.</p
      >
    </div>
  </div>
  {#each requestedItems as product, pindex (product.id)}
    <CartProduct
      Cart={cartService}
      {product}
      {order}
      {callbacks}
      {pindex}
      {showLoading}
      bind:customPricingMode
    />
  {/each}
</div>
